var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8416 2.43359L15.7583 4.61693C17.1749 5.24193 17.1749 6.27526 15.7583 6.90026L10.8416 9.08359C10.2833 9.33359 9.3666 9.33359 8.80827 9.08359L3.8916 6.90026C2.47493 6.27526 2.47493 5.24193 3.8916 4.61693L8.80827 2.43359C9.3666 2.18359 10.2833 2.18359 10.8416 2.43359Z",
    stroke: "#172B4D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.16602C2.5 9.86602 3.025 10.6743 3.66667 10.9577L9.325 13.4743C9.75833 13.666 10.25 13.666 10.675 13.4743L16.3333 10.9577C16.975 10.6743 17.5 9.86602 17.5 9.16602",
    stroke: "#172B4D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.334C2.5 14.109 2.95833 14.809 3.66667 15.1257L9.325 17.6423C9.75833 17.834 10.25 17.834 10.675 17.6423L16.3333 15.1257C17.0417 14.809 17.5 14.109 17.5 13.334",
    stroke: "#172B4D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.37774966c9d4bacf9cf3a88c4a5f8c79.svg";
export { ForwardRef as ReactComponent };